export default __webpack_public_path__ + "media/images/temporary/wholesale-1-77e28ded203fa45f914e084e5b06ddc0.jpg";